import React, { useMemo } from 'react';
import { ConversationUpdateModal } from '../../conversation-update-modal/conversation-update-modal';
import { SearchBar } from '../../../components/search-bar';
import { ModalContentsList } from '../../modal-contents-list';
import { CreateTagView } from './create-tag-view';
import './tags-modal.scss';
import { SVGS } from '../../../assets';
import { ModalContentItemData } from '../../../types';
import { camelCase, startCase } from 'lodash';
import { TagsIcon, TagsKey } from '../../contstants';
import {
  ConversationData,
  dispatch,
  updateSearchKey,
} from '@zonofi/zono-money-store';
import { useAssignTags } from '../../hooks/assign-tags';

interface TagsModalProps {
  open: boolean;
  onClose: () => void;
  conversation: ConversationData;
  findTagType: (tag: string) => TagsKey;
  updateConversations: (item: ConversationData) => void;
}

export const TagsModal: React.FC<TagsModalProps> = ({
  onClose,
  open,
  conversation,
  findTagType,
  updateConversations,
}) => {
  const {
    channelName = '',
    title = '',
    // metadata: { tags: assignedTags = [] },
  } = conversation;
  const { onRemoveTag, onAssignTag } = useAssignTags({
    conversation,
    updateConversations,
  });

  const onCloseModal = () => {
    dispatch(updateSearchKey(''));
    onClose();
  };

  const assignedTags: string[] = [];
  const assignedData: ModalContentItemData[] = useMemo(
    () =>
      assignedTags.length > 0
        ? assignedTags?.map((tag: string) => {
            const tagKey = findTagType(tag);
            return {
              title: startCase(camelCase(tag)),
              icon: <span>{TagsIcon[tagKey]}</span>,
              onPress: () => {
                onRemoveTag(tag);
                onCloseModal();
              },
            };
          })
        : [
            {
              title: 'None',
              icon: <span></span>,
              onPress: () => {},
            },
          ],
    [assignedTags]
  );

  return (
    <ConversationUpdateModal
      open={open}
      onClose={onCloseModal}
      header="Assign Tags"
      customerName={channelName || title}
    >
      <div className="tag-modal-search-container">
        <SearchBar
          placeholderText={'Search Or Create Tags'}
          className="tag-modal-search-bar"
        />
      </div>
      <div className="tag-modal-section">
        <div className="tag-modal-section-title font-semibold">ASSIGNED</div>
        <ModalContentsList
          data={assignedData}
          showSelection={false}
          endIcon={
            assignedTags.length > 0 ? (
              <img src={SVGS.Remove} alt="" />
            ) : undefined
          }
        />
      </div>
      <div className="tag-modal-section">
        <div className="tag-modal-section-title font-semibold">SUGGESTED</div>
        <ModalContentsList
          data={[]}
          showSelection={false}
          emptyView={
            <CreateTagView
              onCreateTag={(tag) => {
                onAssignTag(tag);
                onCloseModal();
              }}
            />
          }
        />
      </div>
    </ConversationUpdateModal>
  );
};
